/**
 * Off-canvas menu
 * Menu that slides out from the left. Can be "swiped off" to close.
 * Pointer Events Polyfill (PEP) is used for browsers without
 * a unified (mouse/touch) events system.
 */

(function($) {
    var $wrapper = $('.site-wrapper'),
        $curtain = $('.loading-overlay'),
        $toggler = $("[data-toggle='menu']"),
        $menu = $('.menu'),
        menuWidth = $('.menu').width(),
        $currentMenu = null,
        dragging = false,
        prevPageX = null,
        dragStartX = null,
        pM = 0;

    var methods = {
        init: function(options) {
            var self = this;

            // Prepare for use with PEP polyfill
            // $menu.attr( "touch-action", "none" );
            $curtain.attr('touch-action', 'none');

            $toggler.on('pointerup', function(e) {
                e.stopPropagation();
                e.preventDefault();

                var m = $(e.target).data('target');
                var $m = $(m);

                if ($m.data('open') == true) {
                    methods.close();
                } else {
                    methods.open($m);
                }
            });

            $(document).on('pointerdown', function(e) {
                // If this event was fired inside a menu and not on a button or slider
                if ($(e.target).closest('.menu')[0] && !$(e.target).closest('.nstSlider, .btn')[0]) {
                    dragging = true;

                    dragStartX = e.pageX;
                }
            });

            $(document).on('pointermove', function(e) {
                if (dragging) {
                    // Get current translateX value
                    var tX = getTranslateX();

                    // Find distance between events
                    prevPageX = prevPageX || e.pageX;
                    var pX = prevPageX - e.pageX;

                    // Calculate the amount to translate the menu (multiplied by two to increase responsiveness)
                    var mX = Math.max(Math.min(tX - pX * 2, 0), -menuWidth);

                    if ($currentMenu) {
                        // Update the matrix transformation
                        $currentMenu.css({
                            transform: 'matrix(1, 0, 0, 1, ' + mX + ', 0)'
                        });
                    }

                    prevPageX = e.pageX;
                }
            });

            $(document).on('pointerup', function(e) {
                var $m = $(e.target).closest('.menu');

                // If this was fired on a close button
                if ($(e.target).is('[data-dismiss]')) {
                    e.stopPropagation();
                    e.preventDefault();

                    methods.close();

                    // If this was fired outside the menu
                } else if (!$m[0]) {
                    // Make sure it wasn't at the end of a swipe
                    if ($currentMenu && !dragging) {
                        methods.close();
                    }

                    // If this was fired inside the menu and not on a slider
                } else if (!$(e.target).closest('.nstSlider')[0]) {
                    // Get current translateX value
                    var tX = getTranslateX();

                    // Find distance between start and end of drag
                    var dX = dragStartX - e.pageX;

                    // Snap menu open or closed
                    if (dX > 150) {
                        methods.close();
                    } else {
                        $m.css({
                            transform: 'translate3d(0, 0, 0)'
                        });
                    }
                }

                // Stop dragging
                dragging = false;

                // Reset dragStartX and prevPageX
                dragStartX = null;
                prevPageX = null;
            });
        },
        open: function($m) {
            $m = $m || $currentMenu;

            if ($m) {
                $m.css({
                    transform: 'translate3d(0, 0, 0)'
                }).data('open', true);
            }

            $('body').addClass('menu-active');
            $wrapper.addClass('lock');

            $currentMenu = $m;
        },
        close: function($m) {
            $m = $m || $currentMenu;

            if ($m) {
                $m.css({
                    transform: 'translate3d(-100%, 0, 0)'
                })
                    .removeClass('open')
                    .data('open', false);
            }

            $('body').removeClass('menu-active');
            $wrapper.removeClass('lock');

            $currentMenu = null;
        }
    };

    $.fn.offCanvasMenu = function(methodOrOptions) {
        if (methods[methodOrOptions]) {
            let callCall;
            if (Array.prototype.slice) {
                callCall = Array.prototype.slice.call(arguments, 1);
            }
            return methods[methodOrOptions].apply(this, callCall);
        } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
            // Default to "init"
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + methodOrOptions + ' does not exist on jQuery.offCanvasMenu');
        }
    };

    function getTranslateX() {
        if (!$currentMenu) {
            return 0;
        }
        // Gets the translateX value from the current transformation matrix
        var t = $currentMenu.css('transform').split(',')[4];
        return parseInt(t, 10);
    }
})(jQuery);
